var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipagamento(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.104,
    height: 53.931,
    viewBox: "0 0 95.104 53.931"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Multipagamento",
    transform: "translate(-0.003 0.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_773",
    "data-name": "Caminho 773",
    d: "M44.737,25.572a3.08,3.08,0,0,1-3.171,2.8,2.171,2.171,0,0,1-1.718-.647,2.492,2.492,0,0,1-.373-2.054l2.305-13.9H35.705L33.4,25.689a6.525,6.525,0,0,0,1.322,5.457,7.76,7.76,0,0,0,6.083,2.48c5.027,0,9.221-3.294,9.975-7.831L53.1,11.772H47.025ZM19.812,20.685l-3.291-8.913H10.693L7.1,33.45h6.075l1.539-9.276,1.921,4.4h3.84l3.312-4.312L22.263,33.45h6.075l3.593-21.678H26.054Zm43.463-8.913H57.2L53.606,33.45H68.954l.869-5.25H60.55Zm31.5,0L91.185,33.45h6.075l3.593-21.678Z",
    transform: "translate(-5.747 -9.644)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_494",
    "data-name": "Grupo 494",
    transform: "translate(0.003 28.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_774",
    "data-name": "Caminho 774",
    d: "M3.782,149.44a2.235,2.235,0,0,1,2.478,2.768,2.817,2.817,0,0,1-3.038,2.416H2.036L1.7,156.657a.184.184,0,0,1-.2.165H.17a.155.155,0,0,1-.164-.2l1.156-7.021a.175.175,0,0,1,.19-.165Zm.765,2.632a.883.883,0,0,0-.974-1.147H2.64l-.367,2.22h.953A1.19,1.19,0,0,0,4.546,152.072Z",
    transform: "translate(-0.003 -149.303)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_775",
    "data-name": "Caminho 775",
    d: "M53.427,156.814a.176.176,0,0,1-.2-.165l-.171-1.208H50.652l-.555,1.238a.206.206,0,0,1-.211.135H48.419c-.139,0-.194-.082-.133-.217l3.437-7.032a.215.215,0,0,1,.211-.135H53.5a.194.194,0,0,1,.207.165l1.229,7.032c.023.114-.04.186-.167.186Zm-.945-5.586c-.287.681-.729,1.756-1.181,2.747h1.562c-.126-1.021-.262-2.087-.339-2.747Z",
    transform: "translate(-39.082 -149.295)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_776",
    "data-name": "Caminho 776",
    d: "M107.77,156.363a2.331,2.331,0,0,1-2.459-2.84l.346-2.21a3.063,3.063,0,0,1,3.293-2.593,4.04,4.04,0,0,1,2.41.744.17.17,0,0,1,.027.259l-.808.9a.181.181,0,0,1-.257.042,2.631,2.631,0,0,0-1.516-.443,1.362,1.362,0,0,0-1.432,1.25l-.346,2.168a.949.949,0,0,0,.974,1.219,2.779,2.779,0,0,0,1.195-.278l.223-1.292h-1.134a.155.155,0,0,1-.164-.2l.164-.981a.175.175,0,0,1,.19-.165h2.589a.155.155,0,0,1,.164.2l-.5,3.045a.328.328,0,0,1-.1.2A4.505,4.505,0,0,1,107.77,156.363Z",
    transform: "translate(-85.248 -148.72)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_777",
    "data-name": "Caminho 777",
    d: "M162,156.814a.176.176,0,0,1-.2-.165l-.171-1.208h-2.408l-.555,1.238a.206.206,0,0,1-.211.135h-1.467c-.139,0-.194-.082-.133-.217l3.437-7.032a.215.215,0,0,1,.211-.135h1.562a.194.194,0,0,1,.207.165l1.229,7.032c.023.114-.04.186-.167.186Zm-.947-5.586c-.287.681-.729,1.756-1.181,2.747h1.562c-.126-1.021-.262-2.087-.339-2.747Z",
    transform: "translate(-127.001 -149.295)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_778",
    "data-name": "Caminho 778",
    d: "M215.791,156.814a.159.159,0,0,1-.175-.2l1.147-7.021a.181.181,0,0,1,.19-.165h1.508a.2.2,0,0,1,.217.154l.567,1.765c.183.641.47,1.683.573,2.117h.032c.238-.424.841-1.476,1.267-2.138l1.166-1.786a.231.231,0,0,1,.223-.114h1.562a.158.158,0,0,1,.175.2l-1.147,7.021a.184.184,0,0,1-.2.165h-1.3a.167.167,0,0,1-.175-.2l.211-1.311c.124-.8.4-2.21.614-3.273l-.053-.01c-.249.476-.808,1.425-1.225,2.1l-.666,1.033a.214.214,0,0,1-.211.124h-.974a.211.211,0,0,1-.217-.154l-.34-1.054c-.183-.641-.445-1.527-.55-1.993h-.053c-.12,1.084-.3,2.3-.434,3.2l-.221,1.373c-.01.114-.082.165-.2.165Z",
    transform: "translate(-174.602 -149.295)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_779",
    "data-name": "Caminho 779",
    d: "M287.547,150.759a.181.181,0,0,1-.19.165h-2.91l-.242,1.436h2.547a.152.152,0,0,1,.164.2l-.185,1.084a.181.181,0,0,1-.19.165h-2.579l-.251,1.539h3.028a.167.167,0,0,1,.175.2l-.173,1.126a.177.177,0,0,1-.2.165h-4.569a.163.163,0,0,1-.175-.2l1.168-7.021a.181.181,0,0,1,.19-.165h4.4a.158.158,0,0,1,.175.2Z",
    transform: "translate(-228.197 -149.311)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_780",
    "data-name": "Caminho 780",
    d: "M335.24,156.814a.155.155,0,0,1-.164-.2l1.156-7.021a.175.175,0,0,1,.19-.165h1.413a.2.2,0,0,1,.217.145l.89,2.446c.261.753.567,1.744.7,2.22l.053-.01c.089-.919.232-1.961.377-2.861l.289-1.777a.181.181,0,0,1,.19-.165h1.3a.159.159,0,0,1,.175.2l-1.156,7.021a.184.184,0,0,1-.2.165h-1.4a.22.22,0,0,1-.217-.145l-.884-2.189a18.739,18.739,0,0,1-.784-2.457l-.042.021c-.078.981-.186,2.106-.352,3.057l-.251,1.548a.181.181,0,0,1-.19.165H335.24Z",
    transform: "translate(-271.34 -149.295)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_781",
    "data-name": "Caminho 781",
    d: "M400.473,149.44c.127,0,.194.072.175.2l-.194,1.136a.17.17,0,0,1-.19.165h-1.851l-.945,5.72a.181.181,0,0,1-.19.165H395.94a.155.155,0,0,1-.164-.2l.945-5.689h-1.83a.163.163,0,0,1-.175-.2l.194-1.136a.181.181,0,0,1,.19-.165Z",
    transform: "translate(-319.639 -149.303)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_782",
    "data-name": "Caminho 782",
    d: "M448.616,156.39c-1.83,0-2.785-1.28-2.486-3.118l.3-1.828a3.155,3.155,0,0,1,3.407-2.7,2.39,2.39,0,0,1,2.528,3.057l-.3,1.828A3.155,3.155,0,0,1,448.616,156.39Zm.219-1.508a1.451,1.451,0,0,0,1.506-1.352l.308-1.889c.135-.826-.2-1.394-1.01-1.394a1.422,1.422,0,0,0-1.484,1.343l-.32,1.87C447.7,154.3,448.044,154.882,448.835,154.882Z",
    transform: "translate(-361.229 -148.736)",
    fill: "#0f3d64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_495",
    "data-name": "Grupo 495",
    transform: "translate(61.628 -0.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_783",
    "data-name": "Caminho 783",
    d: "M323.99,10.906A22.454,22.454,0,0,1,336.553,8.26a23.771,23.771,0,0,1,6.378,1.383,19.257,19.257,0,0,1,5.577,3.135c-2.157-.35-4.137-.877-6.165-1.175-2.01-.333-4-.612-6-.759s-4.013-.192-6.056-.15C328.237,10.7,326.176,10.9,323.99,10.906Z",
    transform: "translate(-323.99 -6.611)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_784",
    "data-name": "Caminho 784",
    d: "M340.621,10.214a2.2,2.2,0,0,1-2.241,1.969,1.978,1.978,0,0,1-1.444-2.467,2.193,2.193,0,0,1,2.241-1.967,1.977,1.977,0,0,1,1.444,2.465Z",
    transform: "translate(-334.439 -6.237)",
    fill: "#1fc3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_785",
    "data-name": "Caminho 785",
    d: "M423.7,17.368a1.65,1.65,0,0,1-1.782,1.387,1.49,1.49,0,0,1-1.208-1.8,1.647,1.647,0,0,1,1.782-1.385,1.486,1.486,0,0,1,1.208,1.8Z",
    transform: "translate(-402.294 -12.573)",
    fill: "#1fc3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_786",
    "data-name": "Caminho 786",
    d: "M379.993,3.578a3.334,3.334,0,0,1-3.519,2.893,3.008,3.008,0,0,1-2.332-3.692,3.333,3.333,0,0,1,3.519-2.893,3.01,3.01,0,0,1,2.332,3.692Z",
    transform: "translate(-364.554 0.139)",
    fill: "#1fc3f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_496",
    "data-name": "Grupo 496",
    transform: "translate(64.793 0.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_787",
    "data-name": "Caminho 787",
    d: "M357.825,24.78l.4-2.564,1.077-.521.04,0,1.162-7.371-1.023-.063.165-1.048-1.023-.063.165-1.048-2.045-.124.165-1.05-3.07-.186.166-1.048-2.047-.124.662-4.2L351.6,5.315l.164-1.05L349.69,4.14l-1.187.987,0,.008-1.953.942-1.156,7.331-2.305-.141-1.953.949-.171,1.078-.331,2.1,1.023.063-.165,1.048,1.023.063-.331,2.1,1.023.063-.331,2.1,1.023.061-.331,2.1,1.023.063-.331,2.1-.165,1.05,9.206.559,1.054.063,1.953-.949.405-2.564,1.075-.521Z",
    transform: "translate(-340.63 -4.14)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_788",
    "data-name": "Caminho 788",
    d: "M348.156,27.412l-1.023-.063.331-2.1-1.021-.061.329-2.1-1.021-.063.331-2.1-1.023-.063.165-1.048L344.2,19.76l.352-2.231,1.487-.723,2.731.165,1.2-7.582,1.955-.942,2.056-.689-.166,1.05,1.023.061-.662,4.2,2.047.124-.165,1.048,3.068.186-.165,1.05L361,15.6l-.165,1.048,1.023.063-.165,1.048,1.023.063-1.012,6.4-1.118.544-.4,2.541-1.118.542-.4,2.564-1.487.723-9.52-.578Z",
    transform: "translate(-343.521 -7.071)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_789",
    "data-name": "Caminho 789",
    d: "M367.856,14.359l.165-1.048L367,13.248l.165-1.048-2.047-.124.165-1.048-3.068-.188.165-1.048-2.047-.124.662-4.194-1.023-.063.165-1.048L358.09,4.24l-.165,1.048L356.9,5.225l-1.489,9.438-1.023-.063.165-1.048-3.07-.186-.165,1.048-.082.525-.247,1.573,1.023.063-.165,1.048,1.023.063-.331,2.1,1.023.063-.331,2.1,1.023.063-.331,2.1,1.023.063-.331,2.09-.165,1.048,9.208.559,1.023.063.5-3.146,1.023.063.5-3.146,1.023.063,1.158-7.34Z",
    transform: "translate(-349.019 -4.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_790",
    "data-name": "Caminho 790",
    d: "M372.663,22.055l-1.023-.061L373.626,9.41l1.023.063Z",
    transform: "translate(-365.742 -8.408)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_791",
    "data-name": "Caminho 791",
    d: "M389.507,5.394,387.46,5.27l.165-1.05,2.047.126Z",
    transform: "translate(-378.553 -4.205)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_792",
    "data-name": "Caminho 792",
    d: "M391.411,19.891l-1.021-.063,1.489-9.438,1.021.063Z",
    transform: "translate(-380.925 -9.201)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_793",
    "data-name": "Caminho 793",
    d: "M401.287,33.944l-2.047-.126.165-1.048,2.047.124Z",
    transform: "translate(-388.092 -27.324)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_794",
    "data-name": "Caminho 794",
    d: "M407.543,47.659,406.52,47.6l.5-3.146,1.023.063Z",
    transform: "translate(-393.987 -36.783)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_795",
    "data-name": "Caminho 795",
    d: "M412.2,40.174l-3.07-.186.165-1.048,3.07.186Z",
    transform: "translate(-396.101 -32.321)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_796",
    "data-name": "Caminho 796",
    d: "M422.813,54.155l-1.023-.063.5-3.142,1.023.061Z",
    transform: "translate(-406.353 -42.046)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_797",
    "data-name": "Caminho 797",
    d: "M426.447,46.6,424.4,46.48l.165-1.05,2.045.126Z",
    transform: "translate(-408.466 -37.576)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_798",
    "data-name": "Caminho 798",
    d: "M435.3,52.711l-1.023-.063.167-1.048,1.021.063Z",
    transform: "translate(-416.467 -42.573)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_799",
    "data-name": "Caminho 799",
    d: "M434.593,64.843l-1.023-.063,1.158-7.34,1.023.063Z",
    transform: "translate(-415.892 -47.302)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_800",
    "data-name": "Caminho 800",
    d: "M426.6,98.909l-1.023-.063.5-3.146,1.023.063Z",
    transform: "translate(-409.422 -78.285)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_801",
    "data-name": "Caminho 801",
    d: "M418.621,115.127l-1.021-.063.5-3.144,1.021.061Z",
    transform: "translate(-402.96 -91.419)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_802",
    "data-name": "Caminho 802",
    d: "M378.4,121.607l-9.208-.559.165-1.048,9.208.559Z",
    transform: "translate(-363.758 -97.962)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_803",
    "data-name": "Caminho 803",
    d: "M369.023,59.811,368,59.748l.165-1.048,1.023.063Z",
    transform: "translate(-362.794 -48.322)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_804",
    "data-name": "Caminho 804",
    d: "M355.8,53.444l-3.07-.186.167-1.048,3.068.186Z",
    transform: "translate(-350.428 -43.067)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_805",
    "data-name": "Caminho 805",
    d: "M352.021,59.879,351,59.818l.329-2.1,1.023.063Z",
    transform: "translate(-349.028 -47.529)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_806",
    "data-name": "Caminho 806",
    d: "M356.523,70.181,355.5,70.12l.165-1.05,1.023.063Z",
    transform: "translate(-352.672 -56.72)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_807",
    "data-name": "Caminho 807",
    d: "M360.163,77.071l-1.023-.063.331-2.1,1.023.063Z",
    transform: "translate(-355.619 -61.449)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_808",
    "data-name": "Caminho 808",
    d: "M363.8,88.429l-1.023-.063.331-2.1,1.023.061Z",
    transform: "translate(-358.567 -70.648)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_809",
    "data-name": "Caminho 809",
    d: "M367.443,99.779l-1.023-.061.331-2.1,1.023.063Z",
    transform: "translate(-361.515 -79.839)",
    fill: "#0f3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_810",
    "data-name": "Caminho 810",
    d: "M371.083,111.131l-1.023-.063.331-2.1,1.023.063Z",
    transform: "translate(-364.462 -89.03)",
    fill: "#0f3d64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_498",
    "data-name": "Grupo 498",
    transform: "translate(30.063 41.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_811",
    "data-name": "Caminho 811",
    d: "M184.915,216.69a6.31,6.31,0,0,0-5.573,3.315,3.16,3.16,0,0,0-.548-.046,3.789,3.789,0,0,0-1.347.23,2.415,2.415,0,0,0-.3-.584,2.359,2.359,0,0,0-2.174-.964h-1.569a.922.922,0,0,0-.462.124.937.937,0,0,0-.476-.124h-.641a.894.894,0,0,0-.915.892v.432h-.017a2.413,2.413,0,0,0-1.872.816,1.756,1.756,0,0,0-.124-.143,2.347,2.347,0,0,0-1.784-.677,2.536,2.536,0,0,0-1.421.382,1.916,1.916,0,0,0-1.189-.382,2.191,2.191,0,0,0-.711.12.9.9,0,0,0-.365-.076h-.47a.918.918,0,0,0-.356-.8,3.178,3.178,0,0,0-1.915-.664,2.548,2.548,0,0,0-2.648,2.671v1.653a2.6,2.6,0,0,0,.879,2.077,2.738,2.738,0,0,0,1.782.618,3.131,3.131,0,0,0,1.478-.344.91.91,0,0,0,.626.247h.647a.917.917,0,0,0,.915-.915v-.569h.407a2.22,2.22,0,0,0,.447.858,2.356,2.356,0,0,0,1.872.723,7.005,7.005,0,0,0,1.634-.217.876.876,0,0,0,.521-.361,2.6,2.6,0,0,0,1.729.578,5.531,5.531,0,0,0,1.8-.323.843.843,0,0,0,.576.228h.776a.854.854,0,0,0,.854-.854v-.626a2.859,2.859,0,0,0,1.368-.337c.057,1.166.993,1.913,2.418,1.913.107,0,.219,0,.329-.01a6.343,6.343,0,1,0,5.818-8.864Z",
    transform: "translate(-158.04 -216.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_497",
    "data-name": "Grupo 497",
    transform: "translate(0.806 0.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_812",
    "data-name": "Caminho 812",
    d: "M277.537,220.91a5.538,5.538,0,0,0-4.949,3.051,1.849,1.849,0,0,1,.909,1.71v2.168a.607.607,0,0,1-.379.571l-.023.009-.025.008a5.63,5.63,0,0,1-.651.15,5.54,5.54,0,1,0,5.117-7.667Z",
    transform: "translate(-251.47 -220.91)",
    fill: "#1ac3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_813",
    "data-name": "Caminho 813",
    d: "M165.637,235.361l-.306-.491a.123.123,0,0,0-.076-.07.11.11,0,0,0-.1.032,1.616,1.616,0,0,1-1.025.344.908.908,0,0,1-.981-1.014v-1.622a.909.909,0,0,1,.974-1.006,1.6,1.6,0,0,1,.962.321.13.13,0,0,0,.108.025.108.108,0,0,0,.067-.063l.308-.495a.133.133,0,0,0-.027-.183,2.367,2.367,0,0,0-1.419-.491,1.741,1.741,0,0,0-1.845,1.868v1.653a1.754,1.754,0,0,0,1.858,1.894,2.194,2.194,0,0,0,1.482-.51A.152.152,0,0,0,165.637,235.361Z",
    transform: "translate(-162.28 -228.797)",
    fill: "#103e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_814",
    "data-name": "Caminho 814",
    d: "M218.772,235.7a2.353,2.353,0,0,0,.624-.078.123.123,0,0,0,.089-.12v-1.933a.17.17,0,0,0-.093-.152,1.374,1.374,0,0,0-.635-.143.746.746,0,0,0-.858.831v.7c0,.656.327.894.873.894m.713-4.447c0-.063.051-.089.114-.089h.641c.063,0,.114.015.114.1v4.856a.074.074,0,0,1-.015.042.159.159,0,0,1-.068.04,4.679,4.679,0,0,1-1.522.274,1.545,1.545,0,0,1-1.719-1.68V234.1a1.539,1.539,0,0,1,1.636-1.619,2.1,2.1,0,0,1,.82.167Z",
    transform: "translate(-206.616 -229.21)",
    fill: "#103e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_815",
    "data-name": "Caminho 815",
    d: "M240.006,231.16h-1.569a.088.088,0,0,0-.1.1v5.084a.04.04,0,0,0,.04.04h.776a.053.053,0,0,0,.053-.053v-1.347a.08.08,0,0,1,.08-.08h.675a1.819,1.819,0,0,0,1.354-.489,1.863,1.863,0,0,0,.534-1.411,2.124,2.124,0,0,0-.331-1.217A1.575,1.575,0,0,0,240.006,231.16Zm.048,2.9h-.767a.08.08,0,0,1-.08-.08v-1.9a.08.08,0,0,1,.08-.08h.808a.793.793,0,0,1,.622.224.913.913,0,0,1,.226.654,1.293,1.293,0,0,1-.221.824A.869.869,0,0,1,240.054,234.061Z",
    transform: "translate(-223.873 -229.21)",
    fill: "#103e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_816",
    "data-name": "Caminho 816",
    d: "M184.657,239.049a.108.108,0,0,1-.146.006.832.832,0,0,0-.517-.164.637.637,0,0,0-.618.706v2.288a.114.114,0,0,1-.114.114h-.647a.114.114,0,0,1-.114-.114v-3.627a.114.114,0,0,1,.114-.114h.624a.114.114,0,0,1,.114.114v.255a1.3,1.3,0,0,1,.964-.413,1.128,1.128,0,0,1,.787.285.125.125,0,0,1,.01.184Z",
    transform: "translate(-178.654 -234.83)",
    fill: "#103e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_817",
    "data-name": "Caminho 817",
    d: "M261.744,241.752v-2.168a1.4,1.4,0,0,0-1.586-1.493,2.638,2.638,0,0,0-1.48.392c-.025.019-.034.046,0,.107l.3.5a.088.088,0,0,0,.059.044.09.09,0,0,0,.072-.019,2.013,2.013,0,0,1,.98-.24c.557,0,.774.215.774.765v.108l-.017,0a5.977,5.977,0,0,0-.757-.059c-1.048,0-1.586.428-1.586,1.174,0,1.107,1.113,1.225,1.617,1.225a5.749,5.749,0,0,0,1.543-.223A.114.114,0,0,0,261.744,241.752Zm-.873-.576a.057.057,0,0,1-.046.057,3.549,3.549,0,0,1-.7.082c-.521,0-.759-.135-.759-.46s.213-.5.751-.5a5.526,5.526,0,0,1,.7.055.056.056,0,0,1,.049.055Z",
    transform: "translate(-240.206 -234.822)",
    fill: "#103e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_818",
    "data-name": "Caminho 818",
    d: "M200.237,239.829a1.849,1.849,0,0,0-.407-1.3,1.593,1.593,0,0,0-1.2-.428,1.522,1.522,0,0,0-1.269.515,2.567,2.567,0,0,0-.409,1.586,2.2,2.2,0,0,0,.388,1.447,1.6,1.6,0,0,0,1.267.447,6.242,6.242,0,0,0,1.446-.194.086.086,0,0,0,.063-.082l-.011-.514a.062.062,0,0,0-.021-.048.073.073,0,0,0-.048-.017c-.2.017-.47.038-.624.046-.1,0-.2.011-.295.019-.124.009-.24.019-.337.019a1.779,1.779,0,0,1-.51-.059.47.47,0,0,1-.276-.215.828.828,0,0,1-.067-.373c0-.122.015-.158.072-.158h2.079a.141.141,0,0,0,.141-.139Zm-.972-.063a.076.076,0,0,1-.059.025H197.99a.083.083,0,0,1-.057-.025.086.086,0,0,1-.023-.061,1.076,1.076,0,0,1,.165-.616.659.659,0,0,1,.542-.2.624.624,0,0,1,.523.194,1.084,1.084,0,0,1,.146.62A.08.08,0,0,1,199.265,239.766Z",
    transform: "translate(-190.355 -234.83)",
    fill: "#103e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_819",
    "data-name": "Caminho 819",
    d: "M289.087,239.8a1.446,1.446,0,0,0-.725-1.366c-.046-.027-.093-.049-.143-.072s-.1-.042-.154-.061a2.25,2.25,0,0,0-.711-.11H283.6a1.563,1.563,0,0,0-1.752,1.668v.689a1.5,1.5,0,0,0,1.645,1.573,2.306,2.306,0,0,0,.846-.167c.023.767-.31,1.056-.881,1.056a1.585,1.585,0,0,1-.989-.316.094.094,0,0,0-.152.03l-.3.466c-.038.068-.038.114.021.152a2.289,2.289,0,0,0,1.486.472c1.084,0,1.653-.671,1.653-1.8v-3h2.271a.773.773,0,0,1,.772.772v.942a.8.8,0,0,1-.451.732.835.835,0,0,1-1.168-.734s0-.852,0-1.126c0-.044-.076-.063-.116-.042-.211.107-.588.308-.709.369a.065.065,0,0,0-.036.059v.8A1.541,1.541,0,0,0,287,242.272a2.862,2.862,0,0,0,.453.04,1.612,1.612,0,0,0,1.624-1.383c0-.048.008-.1.008-.146C289.087,240.781,289.087,239.8,289.087,239.8Zm-4.778,1.364a1.335,1.335,0,0,1-.755.183c-.464,0-.837-.19-.837-.789V239.8c0-.652.36-.835.884-.835a2.793,2.793,0,0,1,.71.084v2.109Z",
    transform: "translate(-259.107 -234.903)",
    fill: "#fff"
  }))))));
}
export default __webpack_public_path__ + "static/multipagamento.da4d5dd0.svg";
export { SvgMultipagamento as ReactComponent };